// extracted by mini-css-extract-plugin
export var sliderRange = "_q0-2";
export var sliderRoot = "_q0-0";
export var sliderThumb = "_q0-3";
export var sliderTrack = "_q0-1";